/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {ActivatedRoute, Router } from '@angular/router';
import {
  NB_AUTH_OPTIONS,
  NbAuthSocialLink,
  NbAuthService,
  NbAuthResult,
} from '@nebular/auth';
import { getDeepFromObject } from '../../helpers';
import { EMAIL_PATTERN } from '../constants';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NbGlobalLogicalPosition, NbGlobalPhysicalPosition, NbGlobalPosition, NbToastrService,NbThemeService, NbDialogService } from '@nebular/theme';
import { AdminOtpComponent } from '../admin-otp/admin-otp.component';
import { NetworkService } from '../../../@core/utils';
@Component({
  selector: 'ngx-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class NgxLoginComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();

  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.login.redirectDelay');
  showMessages: any = this.getConfigValue('forms.login.showMessages');
  strategy: string = this.getConfigValue('forms.login.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');
  rememberMe = this.getConfigValue('forms.login.rememberMe');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted: boolean = false;
  loginForm: FormGroup;
  alive: boolean = true;
  logicalPositions = NbGlobalLogicalPosition;
  verify_message: boolean=false;
  displayNo:boolean=false;
  messageHeading: string;
  message: any;
  outln: string;
  error: string;
  viewpass: boolean = false;
  changetype: boolean = true

  
  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }

  constructor(protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected themeService: NbThemeService,
    private fb: FormBuilder,
    protected router: Router,
    private dialogService: NbDialogService,
    protected initUserService: InitUserService,
    private toasterService: NbToastrService,
    private route: ActivatedRoute,
    protected network : NetworkService,) { }

  ngOnInit(): void {
    var verify = this.route.snapshot.queryParamMap.get('verify');
    
    if(verify == '1'){
      this.verify_message = true;
    }
    const emailValidators = [
      Validators.pattern(EMAIL_PATTERN),
    ];
    this.isEmailRequired && emailValidators.push(Validators.required);

    const passwordValidators = [
      Validators.minLength(this.minLength),
      Validators.maxLength(this.maxLength),
    ];
    this.isPasswordRequired && passwordValidators.push(Validators.required);

    this.loginForm = this.fb.group({
      email: this.fb.control(''),
      password: this.fb.control('', [...passwordValidators]),
      rememberMe: this.fb.control(false),
    });


  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
      if(event.key == 'Enter'){
      this.login();
    }
  }
  login(): void {
    

    this.user = this.loginForm.value;
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    this.service.authenticate(this.strategy, this.user).subscribe((result: NbAuthResult) => {
      this.submitted = false;
      if (result.isSuccess()) {
        

        this.messages = result.getMessages();

       var id=result['token']['accessTokenPayload']['id'];
       var role =result['token']['accessTokenPayload']['user_type'];
       var email =result['token']['accessTokenPayload']['email'];
       var verfied = result['token']['accessTokenPayload']['is_otp_verified'];
       var firstname = result['token']['accessTokenPayload']['name'];
       var lastname = result['token']['accessTokenPayload']['surname'];
       var mobile = result['token']['accessTokenPayload']['mobile'];
        

        this.initUser(id,role,email,firstname,lastname,mobile);
      } else {
        

        if(result['response'].status == 402){
          this.verify_message = true;
          this.messageHeading = "Sorry";
          this.message = result['response'].error.error;
          this.outln = 'danger';
          this.error ="You dont have access of this portal"
        }else{
          this.errors = result.getErrors();
        }
      }
     if(verfied == 1){
      const redirect = result.getRedirect();
      if (redirect) {
        setTimeout(() => {
          return this.router.navigateByUrl(redirect);
        }, this.redirectDelay);
      }
    }else if(verfied == 0){
// 
this.dialogService.open(AdminOtpComponent,{
        closeOnBackdropClick : false,
        context: {
           email : this.user.email,
          // landingPage : '/auth/login',
          value : 'student',
          user_id:this.user.id
        }
      });
    }
    else{
// 

      if(this.errors.length == 0 && result['response'].status == 402){

        this.toasterService.danger("You dont have access of this portal",'Error',)

     }else{

      
      
      

      this.toasterService.danger(this.errors,'Error',)

     }

      return this.router.navigateByUrl('/auth/login');
    }
      this.cd.detectChanges();
    });
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.options, key, null);
  }

  initUser(id,role,email,firstname,lastname,mobile) {
    

    this.initUserService.initCurrentUser(id,role,email,firstname,lastname,mobile)
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
  viewEye() {
    this.viewpass = !this.viewpass;
    this.changetype = this.viewpass ? false : true;
  }

}
